import { LOGIN } from 'navigation/CONSTANTS'
import { IUserSession } from 'types'

/**
 * Constants for localStorage keys used in the application.
 * These keys are used to store authentication tokens and user data.
 */
const SENTINELA_WEB_TOKEN_KEY = 'sentinela::web::token'
const SENTINELA_WEB_REFRESH_TOKEN_KEY = 'sentinela::web::refresh-token'
const SENTINELA_WEB_CUSTOM_TOKEN_KEY = 'sentinela::web::custom-token'
const SENTINELA_WEB_USER_KEY = 'sentinela::web::user'

/**
 * Storage object to manage authentication tokens and user data
 * It provides methods to get, set, and remove tokens and user information from localStorage.
 */
export const Storage = {
  token: {
    get: () =>
      localStorage.getItem(SENTINELA_WEB_TOKEN_KEY)
        ? (localStorage.getItem(SENTINELA_WEB_TOKEN_KEY) as string)
        : null,
    set: (token: string) =>
      localStorage.setItem(SENTINELA_WEB_TOKEN_KEY, token),
    remove: () => localStorage.removeItem(SENTINELA_WEB_TOKEN_KEY)
  },
  refreshToken: {
    get: () =>
      localStorage.getItem(SENTINELA_WEB_REFRESH_TOKEN_KEY)
        ? (localStorage.getItem(SENTINELA_WEB_REFRESH_TOKEN_KEY) as string)
        : null,
    set: (token: string) =>
      localStorage.setItem(SENTINELA_WEB_REFRESH_TOKEN_KEY, token),
    remove: () => localStorage.removeItem(SENTINELA_WEB_REFRESH_TOKEN_KEY)
  },
  customToken: {
    get: () =>
      localStorage.getItem(SENTINELA_WEB_CUSTOM_TOKEN_KEY)
        ? (localStorage.getItem(SENTINELA_WEB_CUSTOM_TOKEN_KEY) as string)
        : null,
    set: (token: string) =>
      localStorage.setItem(SENTINELA_WEB_CUSTOM_TOKEN_KEY, token),
    remove: () => localStorage.removeItem(SENTINELA_WEB_CUSTOM_TOKEN_KEY)
  },
  user: {
    get: () =>
      localStorage.getItem(SENTINELA_WEB_USER_KEY)
        ? (JSON.parse(
            localStorage.getItem(SENTINELA_WEB_USER_KEY) as string
          ) as IUserSession)
        : null,
    set: (user: IUserSession) =>
      localStorage.setItem(SENTINELA_WEB_USER_KEY, JSON.stringify(user)),
    remove: () => localStorage.removeItem(SENTINELA_WEB_USER_KEY)
  }
}

const logoutListeners = new Set<() => void>()

/**
 * Registra uma limpeza a rodar no logout, antes do redirecionamento. Existe para
 * que serviços (ex.: analytics) limpem o próprio estado sem o storage importá-los.
 */
export const onLogout = (listener: () => void) => {
  logoutListeners.add(listener)
}

/**
 * Auth object to manage user logout
 * It provides a method to clear tokens and user data from localStorage and redirect to the login page.
 */
export const Auth = {
  logout: () => {
    Storage.token.remove()
    Storage.refreshToken.remove()
    Storage.customToken.remove()
    Storage.user.remove()
    logoutListeners.forEach(listener => listener())
    window.location.href = LOGIN
  }
}

export default Storage
